import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { Box } from "@material-ui/core";
import CmtSearch from "@coremat/CmtSearch";
import ParticipantsTable from "./ParticipantsTable";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const ParticipantsContainer = () => {
    const classes = useStyles();
    const [searchVal, setSearchVal] = useState("");
  
    return (
      <CmtCard className={classes.cardRoot}>
        <CmtCardContent className={classes.cardContentRoot}>
          <Box className={classes.actionsContainer}>
            <Box className={classes.buttonsContainer}>
              <Box>
                <CmtSearch
                  border={false}
                  onlyIcon={false}
                  iconPosition="left"
                  align="left"
                  placeholder="جست و جو"
                  value={searchVal}
                  onChange={(e) => setSearchVal(e.target.value)}
                />
              </Box>
            </Box>
          </Box>
          <ParticipantsTable
            searchMode={searchVal.trim().length > 0}
            searchInput={searchVal}
          />
        </CmtCardContent>
      </CmtCard>
    );
  };
  
  export default ParticipantsContainer;
